<div class="search-box {{ dropdownType() }} {{ searchType() }}">
  <div class="search-input-box service field-type-1" [ngClass]="{ show: dropdownType() === 'search' }">
    <button><img src="assets/images/search.svg" alt="" /></button>
    <!-- <img (click)="selectOption('', 'service')" *ngIf="serviceText" class="clear-input" src="assets/images/close.svg" alt=""> -->
    <div
      class="field-input"
      role="button"
      tabindex="0"
      (click)="openDropdown('search', searchInputMob)"
      (keydown.enter)="openDropdown('search', searchInputMob)"
      (keydown.space)="openDropdown('search', searchInputMob)">
      {{ serviceText() }}@if (!serviceText()) {
      <span class="placeholder">Modality</span>
      }
    </div>
    <div class="search-service-pop">
      <div class="mobile-input">
        <button><img src="assets/images/search.svg" alt="" /></button>
        <input
          #searchInputMob
          type="text"
          readonly
          placeholder="Modality"
          [(ngModel)]="serviceText"
          (input)="searchInput()" />
        <button (click)="openDropdown('')">Cancel</button>
      </div>
      <div class="search-service-wrapper for-service">
        @if (filteredPopularCategories().length > 0) {
        <div class="popular-services">
          <ul>
            @for (popular of filteredPopularCategories(); track popular) {
            <li
              [innerHTML]="popular.name | highlight: serviceText()"
              role="button"
              tabindex="0"
              (click)="selectOption(popular.name, 'service')"
              (keydown.enter)="selectOption(popular.name, 'service')"
              (keydown.space)="selectOption(popular.name, 'service')"></li>
            }
          </ul>
        </div>
        }
      </div>
    </div>
  </div>
  @if (searchType() !== 'business') {
  <div class="search-input-box location field-type-1" [ngClass]="{ show: dropdownType() === 'location' }">
    <button><img src="assets/images/pin.svg" alt="" /></button>
    <div
      class="field-input"
      placeholder="Select a location"
      #locationInput
      role="button"
      tabindex="0"
      (click)="openDropdown('location', locationMainInput)"
      (keydown.enter)="openDropdown('location', locationMainInput)"
      (keydown.space)="openDropdown('location', locationMainInput)">
      {{ locationText() }}@if (!locationText()) {
      <span class="placeholder">Select a location</span>
      }
    </div>
    <div class="search-service-pop">
      <div class="mobile-input">
        <button><img src="assets/images/pin.svg" alt="" /></button>
        <input
          #locationMainInput
          type="text"
          id="location-input"
          placeholder="Select a location"
          (focus)="locationFocus()"
          (blur)="locationFocusOut($event)"
          (input)="onLocationTextChanged($event)" />
        <button (click)="openDropdown('')">Cancel</button>
      </div>
      <div class="search-service-wrapper">
        <button class="current-location-btn" loading="lazy" (click)="getmeraLocation()">
          <img src="assets/images/map-location-arrow.svg" alt="" /> USE MY CURRENT LOCATION
        </button>
        <ul>
          @for (location of filteredLocationsList(); track location) {
          <li
            role="button"
            tabindex="0"
            (click)="selectLocation(location)"
            (keydown.enter)="selectLocation(location)"
            (keydown.space)="selectLocation(location)">
            {{ location.displayText }}
          </li>
          }
        </ul>
        <div class="online-section">
          <p>Looking for online telehealth? Select the button below for online appointments.</p>
          <button class="online-btn" (click)="changeToOnline()">
            <img src="assets/images/video.svg" alt="" /> ONLINE AND TELEHEALTH APPOINTMENTS
          </button>
        </div>
      </div>
    </div>
  </div>
  }
  <div class="search-input-box calendar field-type-1">
    <button><img src="assets/images/calendar.svg" alt="" /></button>
    @if (browserTest.IOS || browserTest.ANDROID) {
    <input
      type="date"
      class="field-input"
      placeholder="Today"
      [(ngModel)]="selectedDateText"
      (click)="openDropdown('calendar')"
      (change)="nativeDateChanged($event)"
      [min]="todayDate" />
    } @if (!browserTest.IOS && !browserTest.ANDROID) {
    <input
      class="field-input"
      placeholder="Today"
      [(ngModel)]="selectedDate"
      (click)="openDropdown('calendar'); calender1.open()"
      (dateChange)="dateChanged($event)"
      [matDatepicker]="calender1"
      [min]="todayDate" />
    <mat-datepicker #calender1></mat-datepicker>
    }
  </div>
  @if (loading()) {
  <p class="fetching-location"><i class="fa fa-spin fa-spinner"></i> Fetching coordinates</p>
  }
  <button class="main-search" [disabled]="loading()" (click)="searchNow()">Search</button>
</div>
